module.exports = __webpack_public_path__ + "media/icons/list19-75e51176.png";